(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/views/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/views/fractiongames-page.js');

'use strict';

svs.vikinglotto.views.FractiongamesPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'vikinglotto',
    component: 'fractiongames'
  }],
  template() {
    return svs.vikinglotto.templates.fractiongames_page();
  },
  onDomRefresh() {
    if (svs.vikinglotto.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.render(React.createElement(svs.vikinglotto.components.fractiongames.FractiongamesApp, null), target);
    }
  },
  onDestroy() {
    if (svs.vikinglotto.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.unmountComponentAtNode(target);
    }
  }
});

 })(window);